if (!customElements.get('poke-galaxy-header')) {
  customElements.define(
    'poke-galaxy-header',
    class PokeGalaxyHeader extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('[data-pg-menu-open]');
        this.dialog = this.querySelector('[data-pg-menu-dialog]');
        this.closeButton = this.querySelector('[data-pg-menu-close]');

        if (!this.trigger || !this.dialog || !this.closeButton) return;

        this.handleOpen = () => this.openMenu();
        this.handleClose = () => this.closeMenu();
        this.handleDialogClose = () => this.afterClose();
        this.handleBackdropClick = (event) => {
          if (event.target === this.dialog) this.closeMenu();
        };

        this.trigger.addEventListener('click', this.handleOpen);
        this.closeButton.addEventListener('click', this.handleClose);
        this.dialog.addEventListener('close', this.handleDialogClose);
        this.dialog.addEventListener('click', this.handleBackdropClick);
      }

      disconnectedCallback() {
        this.trigger?.removeEventListener('click', this.handleOpen);
        this.closeButton?.removeEventListener('click', this.handleClose);
        this.dialog?.removeEventListener('close', this.handleDialogClose);
        this.dialog?.removeEventListener('click', this.handleBackdropClick);
        document.body.classList.remove('pg-menu-open');
      }

      openMenu() {
        if (this.dialog.open) return;
        this.dialog.showModal();
        this.trigger.classList.add('is-open');
        this.trigger.setAttribute('aria-expanded', 'true');
        this.trigger.setAttribute('aria-label', 'Close menu');
        document.body.classList.add('pg-menu-open');
        requestAnimationFrame(() => this.closeButton.focus());
      }

      closeMenu() {
        if (this.dialog.open) this.dialog.close();
      }

      afterClose() {
        this.trigger.classList.remove('is-open');
        this.trigger.setAttribute('aria-expanded', 'false');
        this.trigger.setAttribute('aria-label', 'Open menu');
        document.body.classList.remove('pg-menu-open');
        this.trigger.focus();
      }
    }
  );
}
